<template>
  <article class="popup del-confirm" @keypress.enter="confirm">
    <img src="../../../assets/error_icon.svg" alt="">
    <h2 class="title">
      {{$t('popups.unsetGroupConfirm')}}
    </h2>
    <h3 class="items">
      {{title}}
    </h3>
    <div class="btn-cont">
      <button type="button"
              @click="reset"
              class="btn btn-transparent_dark">
        {{$t('btns.cancel')}}
      </button>
      <button type="button"
              @click="confirm"
              class="btn btn-transparent_red">
        {{$t('btns.accept')}}
      </button>
    </div>
    <close-btn :del-btn="true"></close-btn>
  </article>
</template>

<script>
  import {popups} from "../../../mixins/popups";
  import closeBtn from '../closeBtn'
  import {mapMutations, mapState} from 'vuex'

  export default {
    name: 'unsetPopup',
    mixins: [popups],
    components: {
      closeBtn
    },
    computed: {
      ...mapState({
        title: state => state.popups.del.items,
      })
    },
    methods: {
      ...mapMutations({
        setConfirmUnset: 'popups/del/SET_CONFIRM_UNSET',
        setItems: 'popups/del/SET_ITEMS'
      }),
      confirm() {
        this.setConfirmUnset(true);
        this.closeAll();
      },
      reset() {
        this.closeAll()
      }
    },
    destroyed() {
      setTimeout(() => {
        this.setConfirmUnset(false);
        this.setItems('');
      }, 500)

    }
  }
</script>


<style lang="scss" scoped>
  .del-confirm {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  img {
    max-width: 100px;
    margin-bottom: 20px;
  }

  .del-item-confirm {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    position: absolute;
    top: calc(50% - 318px / 2);
    left: calc(50% - 493px / 2);
  }

  .title {
    font-family: $msb;
    font-size: 24px;
    margin-bottom: 10px;
    text-align: center;
    line-height: 100%;
  }

  .items {
    font-family: $mr;
    font-size: 16px;
    margin-bottom: 20px;
  }

  .btn-cont {
    display: flex;

    button {
      margin: 0 10px;
      width: 180px;
    }
  }
</style>
